import React from 'react';
import styled from 'styled-components';

import Illustration from './illustration';

const ErrorContainer = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ErrorMessage = styled.div`
  font-size: 16px;
  letter-spacing: -0.6px;
  line-height: 24px;
  color: #96999c;
  width: 510px;
`;

type Props = {
  errorMessage: string;
};

const ErrorMessageWithIllustration: React.FC<Props> = ({ errorMessage }) => {
  return (
    <ErrorContainer>
      <Illustration name="electric-shock" />
      <br />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorContainer>
  );
};

export default ErrorMessageWithIllustration;
